import {
	SET_CLIENT_ID,
	SET_CLIENT_IDS,
	SET_CLIENT_IDS_LOADED,
	RESET_CLIENT_IDS,
} from './actions';

/**
 * Can be set but not unset
 */
export function clientIdsLoaded(state = 0, action) {
	switch (action.type) {
		case SET_CLIENT_IDS_LOADED:
			return true;
		default:
			return state;
	}
}

export function clientId(state = 0, action) {
	switch (action.type) {
		case SET_CLIENT_ID:
			return action.data;
		default:
			return state;
	}
}

export function clientIds(state = [], action) {
	switch (action.type) {
		case SET_CLIENT_IDS:
			return action.data;
		case RESET_CLIENT_IDS:
			return [];
		default:
			return state;
	}
}
